<template>
  <div class="popup" v-cloak v-show="diffShow">
        <div class="content" id="diffMoney">
               <div class="diff-title" :class="source == 'activity'?'diff-title-bg':''">
                    <div class="title-context" :style="{width:getWidth()}">
                         <!-- <div class="icon-buy title-other-one">
                         </div> -->
                         <div class="title-other-two">
                             <div class="title-up"><b>{{$t('language.paySystem.upUnlimited')}}</b></div>
                             <div :class="source == 'halloween'?'title-des-bg':'title-des'">{{$t('language.paySystem.payDiff')}}</div>
                         </div>
                    </div>
                    <div class="diff-close-position" :class="[loading?'item-readOnly':'',source?'blackFridaySaled-close':'diff-close']" @click="diffShow=false;">
                    </div>
               </div>
               <div class="diff-body">
                    <div class="diff-body-inner">
                         <div class="body-inner-left">
                             <div style="float:left;">
                              <div style="float:left;" class="icon-box">
                              </div>
                              <div style="float:left;width:500Px;position:relative;left:20Px;top:5Px;">
                              <p class="inner-title" v-html="$t('language.paySystem.yearlyUnlimit')"></p>
                              <p class="inner-txt-body">{{$t('language.paySystem.providesUnlimited')}}</p>
                              </div>
                              </div>
                                <!-- 显示下面弹窗 -->
                              <div style="float:left;width:465Px;position:relative;top:15Px;">
                              <p class="inner-txt-footer"><span style="color:rgb(48,77,197)">•</span>  {{$t('language.paySystem.subProduct')}}
                              <span v-if="currencyBefore">{{payInfo.currency}}{{payInfo.nowPrice}} </span>
                               <span v-else>{{payInfo.nowPrice}}{{payInfo.currency}}</span>
                               {{$t('language.paySystem.perYear')}} {{$t('language.paySystem.cancelSubscription')}}</p>
                              <p class="inner-txt-footer" v-if="payInfo.lastFourNumber"><span style="color:rgb(48,77,197)">•</span>  {{$t('language.paySystem.defaultPayment')}} {{payInfo.payMethod}}, xxxxxxxxxxxx{{payInfo.lastFourNumber}}.</p>
                              <p class="inner-txt-footer" v-else><span style="color:rgb(48,77,197)">•</span> {{$t('language.paySystem.defaultPayment')}} {{payInfo.payMethod}}.</p>
                              <p class="inner-txt-footer"><span style="color:rgb(48,77,197)">•</span>  {{$t('language.paySystem.anotherPayment')}}<span class="diff-link" @click="openClick()">{{$t('language.paySystem.clickHere')}}</span>.</p>
                            </div>
                             
                         </div>
                         <div class="body-inner-right">
                              <div class="inner-right-txt" v-if="currencyBefore">
                                  <div :class="payInfo.currency=='$'?'now-price':'now-price-en'">{{payInfo.currency}}{{payInfo.nowPrice}}</div>
                                  <div :class="payInfo.currency=='$'?'old-price':'old-price-en'">
                                     <span v-if="!source"> {{payInfo.currency}}</span>
                                      {{payInfo.oldPrice}}</div>
                                  <div class="inner-right-bottom">
                                      Includes {{payInfo.currency}}{{payInfo.vatPrice}} VAT ({{payInfo.percent}}% on {{payInfo.currency}}{{payInfo.netPrice}}).
                                  </div>
                              </div>
                               <div class="inner-right-txt" v-else>
                                  <div :class="payInfo.currency=='$'?'now-price':'now-price-en'">{{payInfo.nowPrice}}{{payInfo.currency}}</div>
                                  <div :class="payInfo.currency=='$'?'old-price':'old-price-en'">
                                      {{payInfo.oldPrice}}
                                     <span v-if="!source"> {{payInfo.currency}}</span>
                                  </div>
                                  <div class="inner-right-bottom">
                                      Includes {{payInfo.vatPrice}}{{payInfo.currency}} VAT ({{payInfo.percent}}% on {{payInfo.netPrice}}{{payInfo.currency}}).
                                  </div>
                              </div>
                         </div>
                    </div>
               </div>
               <div class="diff-buttom">
                    <div class="bottomOne"  @click="diffShow=false">{{$t('language.common.cancel')}}</div>
                    <div class="bottomTwo" :style="{width:getButtonWidth()}" :class="loading?'item-readOnly':''"   v-loading='loading' @click="upNow()">
                         <span v-if="!loading">{{$t('language.common.upgradeNow')}}</span>
                          <div style="position: absolute;z-index: 2000;float: right;left: 40Px;" v-if="loading">{{$t('language.paySystem.processorder')}}</div>
                    </div>
               </div>
        </div>
  </div>
</template>

<script>
import getCurrencyUtils from '@/js/workspace/get_currency.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
  data () {
    return {
      diffShow: false,
      loading: false,
      source:null,//表明弹窗来源
      payInfo: {
        payMethod: 'Visa',//支付方式
        lastFourNumber: '404T',//信用卡后四位
        changeUrl: '',//改变支付方式连接
        purchaseId: '',//购买的id
        subId: '',//subsCriptionID
        productId: null,//要替换的产品的ID
        nowPrice: 0,//现在的价格
        oldPrice: 0,//以前的价格
        currency: "$",//币种
        vatPrice: 0,//应付的税钱
        netPrice: 0,//不含税的钱
        percent: 0,//税收比例
      },
      currencyBefore: true,//币种位置，0前置，1后置
    }
  },
  watch:{
      diffShow(newValue,oldValue){
        if(this.$parent.nowData){
           this.$parent.nowData[1].loading = false;
           this.$parent.$forceUpdate();
          }
        if(this.source=='halloween'&&this.$parent.$refs.halloweenSaleDialog.showData){
           this.$parent.$refs.halloweenSaleDialog.showData[0].loading = false; 
           this.$parent.$refs.halloweenSaleDialog.$forceUpdate();
        }
         this.$parent.$forceUpdate();
      },
  },
  methods: {
    getButtonWidth(){
      let width;
      if (this.$i18n.locale == "france") {
        width = "210Px";
      }
       if (this.$i18n.locale == "portuguese") {
        width = "190Px";
      }
       if (this.$i18n.locale == "spanish") {
        width = "210Px";
      }
        if (this.$i18n.locale == "italian") {
        width = "195Px";
      }
      if (this.$i18n.locale == "chinese" || this.$i18n.locale == "traditionalChinese") {
        width = "120Px";
      }
       if (this.$i18n.locale == "japanese") {
        width = "120Px";
      }
    return width;
    },
    getWidth () {
      let width;
      if (this.$i18n.locale == "france") {
        width = "340Px";
      }
      if (this.$i18n.locale == "deutsch") {
        width = "330Px";
      }
      if (this.$i18n.locale == "italian") {
        width = "350Px";
      }
      if (this.$i18n.locale == "chinese" || this.$i18n.locale == "traditionalChinese") {
        width = "180Px";
      }
      return width;
    },
    //封装post请求的信息
    packageDataJson (isPreview,subId) {
      var dataJson = {};
      var AlignmentSettings = {};
      AlignmentSettings.AlignToCurrentInterval = true;//立即向客户收取更新费用
      AlignmentSettings.ExtendInterval = true;//按新产品周期算差价
      AlignmentSettings.GetCustomerPricePreviewOnly = isPreview;
      dataJson.AlignmentSettings = AlignmentSettings;
      dataJson.GenerateMail = true;
      dataJson.ProductId = 236257;
      dataJson.Quantity = 1;
      dataJson.RunningNumber = 1;
      dataJson.SubscriptionId = subId;
      dataJson.ForcePriceRecalculation = false;
      dataJson.UpdateAction = "Update";
      if(this.source =='halloween'||this.source =='activity'){//如果是万圣节活动弹窗
          dataJson.CouponCode = "GMQ-H9V-649";
      }
      return dataJson;
    },
    updateItemPreview () {
      var dataJson = this.packageDataJson(true,this.payInfo.subId);
      var self = this;
      this.Utils.doSubinquiryPostRequest('update_subscription_item', dataJson).then(res => {
        //如果请求成功设置显示信息
        if (res.ResultMessage == 'OK') {
          self.diffShow = true;
          self.$parent.sendSubScribeRequest = true;
          self.payInfo.nowPrice = res.AlignmentCustomerGrossPrice;
          var user = commonUtils.getUser();
          if(self.source == 'halloween'||self.source == 'activity'){
          self.payInfo.oldPrice =localStorage.getItem(user.id+'oldGross');  
          }else{
          self.payInfo.oldPrice = res.NextBillingCustomerGrossPrice;
          }
          self.payInfo.netPrice = res.AlignmentCustomerNetPrice;
          self.payInfo.vatPrice = res.AlignmentCustomerVatPrice;
          self.payInfo.percent = ((self.payInfo.vatPrice / self.payInfo.netPrice) * 100);
          self.payInfo.percent = self.payInfo.percent.toFixed(2);
          self.payInfo.currency = getCurrencyUtils.getCurrencyByCurrencyId(res.PriceCurrencyId);
          if(self.payInfo.currency=="€"||self.payInfo.currency=="円"){
            self.currencyBefore=false;
          }else{
            self.currencyBefore=true;
          }
        }else{
          self.$parent.nowData[1].loading=false;
          self.$toast({
                    text: this.$t('language.popup.remindBindEmail.failed'),
                    type: 'success',
                    idValue: "rightContBan"
                });
        }
      }, error => {
             self.$parent.nowData[1].loading=false;
             self.$toast({
                    text: this.$t('language.popup.remindBindEmail.failed'),
                    type: 'success',
                    idValue: "rightContBan"
                });
        });
    },
    //立即进行升级操作
    upNow () {
      var dataJson = this.packageDataJson(false,this.payInfo.subId);
      var self = this;
      this.loading = true;
      this.Utils.doSubinquiryPostRequest('update_subscription_item', dataJson).then(res => {
        //如果请求成功
        if (res.ResultMessage == 'OK') {
         if(self.source =='halloween'){//如果是万圣节活动弹窗
          self.$parent.$refs.halloweenSaleDialog.getUserStatus();
          }
          if(self.$parent.getUserStatus){
          //扣款成功，循环获取最新的user信息，并关闭该界面
          self.$parent.getUserStatus();
          }
        } else {
          self.diffShow=false;
          self.loading=false;  
          //扣款失败打开提醒弹窗
          self.$parent.$refs.payErrorNoticeDialog.errNoticeShow = true;
        }
      },error => {
          self.diffShow=false;
          self.loading=false;  
          //扣款失败打开提醒弹窗
          self.$parent.$refs.payErrorNoticeDialog.errNoticeShow = true;
      });
    },
    getChangeUrl () {
      var self = this;
      this.Utils.doSubinquiryPostRequest('get_by_purchaseIdV', { purchaseId: self.payInfo.purchaseId }).then(res => {
        //如果请求成功
        if (res.ResultMessage == 'OK') {
          let json = JSON.parse(res.PurchaseNotification);
          self.payInfo.changeUrl = json.items[0].recurringBilling.changePaymentSubscriptionUrl;
        }
      });
    },
    openClick () {
      if (this.payInfo.changeUrl) {
        window.open(this.payInfo.changeUrl + '?x-mb=14', '_blank');
        this.diffShow = false;
      }
    }
  }
}
</script>

<style>
.item-readOnly{
     pointer-events: none;
}
#diffMoney {
  width: 880Px;
  height: 430Px;
  border: none !important;
}
.diff-close {
  float: right;
  margin: 10Px 10Px 0 0;
  cursor: pointer;
}
.title-context {
  margin: 0 auto;
  width: 300Px;
  height: 40Px;
}
.diff-title {
  width: 100%;
  height: 80Px;
  text-align: center;
  color: #fff;
  background: rgb(252, 129, 35);
  display: flex;
  align-items: center; /*定义body的元素垂直居中*/
  justify-content: center; /*定义body的里的元素水平居中*/
}

.title-up {
  font-size: 18Px;
  font-family: Helvetica;
}
.title-other-one {
  float: left;
}

.title-other-two {
  float: left;
  position: relative;
  left: 20Px;
}

.title-des {
  position: relative;
  top: 5Px;
  font-size: 14Px;
  color: rgba(255, 255, 255, 0.8);
}
.title-des-bg{
  position: relative;
  top: 5Px;
  font-size: 14Px;
  color: rgba(255, 255, 255, 0.8);
}
.diff-body {
  width: 100%;
  height: 260Px;
}

.diff-body-inner {
  width: 800Px;
  height: 100%;
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  padding: 30Px 0 50Px 0;
  border-bottom: 1Px solid rgb(212, 215, 227);
}
.body-inner-left {
  height: 100%;
  width: 70%;
  float: left;
}
.body-inner-right {
  height: 100%;
  width: 30%;
  float: right;
  position: relative;
}
.inner-title {
  font-size: 18Px;
}
.inner-txt-footer {
  font-size: 14Px;
}
.diff-link {
  color: #2e79f6;
  text-decoration: none;
  cursor: pointer;
}
.body-inner-left p {
  margin-bottom: 15Px;
  padding: 0;
  margin-top: 0;
}

.inner-right-txt {
  width: 100%;
  height: 80Px;
  position: relative;
  top: 30%;
  left: 20Px;
}

.inner-right-bottom {
  float: left;
  font-size: 12Px;
  position: relative;
  top: 10Px;
  color: rgb(48, 77, 197);
}

.now-price {
  float: left;
  font-size: 36Px;
  font-weight: bold;
  position: relative;
  color: rgb(48, 77, 197);
}

.inner-txt-body {
  font-size: 14Px;
  color: rgb(189, 189, 189);
  width: 450Px;
}

.old-price {
  float: left;
  margin-left: 10Px;
  position: relative;
  top: 18Px;
  text-decoration: line-through;
  color: rgb(48, 77, 197);
  font-size: 16Px;
}
.old-price-en {
  float: left;
  margin-left: 10Px;
  position: relative;
  top: 10Px;
  text-decoration: line-through;
  color: rgb(48, 77, 197);
  font-size: 10Px;
}

.now-price-en {
  float: left;
  font-size: 26Px;
  font-weight: bold;
  position: relative;
  color: rgb(48, 77, 197);
}
.diff-buttom {
  font-size: 14Px;
  width: 100%;
  height: 90Px;
  display: flex;
  align-items: center; /*定义body的元素垂直居中*/
  justify-content: center; /*定义body的里的元素水平居中*/
}
.diff-close-position {
  position: relative;
  top: -20Px;
  cursor: pointer;
}
.icon-box {
  width: 60Px;
  height: 78Px;
  background-image: url('../../../assets/images/paySystem/img_box_mc.png') !important;
}
.bottomOne {
  border-radius: 2Px;
  background: #fff;
  border: 1Px solid #b3bcf6;
  color: rgb(85, 98, 180);
  width: 110Px;
  height: 30Px;
  text-align: center;
  line-height: 30Px;
  cursor: pointer;
}

.bottomTwo {
  border-radius: 2Px;
  background: #FF5D31;
  color: #fff;
  width: 170Px;
  height: 30Px;
  margin-left: 20Px;
  text-align: center;
  line-height: 30Px;
  cursor: pointer;
}

#diffMoney .el-loading-spinner .circular {
  height: 0.25rem !important;
  width: 0.25rem !important;
  position: relative;
  top: 30Px;
  margin-left: 10Px;
  float: left;
}
#diffMoney .el-loading-mask {
  background-color: #ff5d31 !important;
  border-radius: 2Px;
  z-index: 10 !important;
}
#diffMoney .el-loading-spinner .path {
  stroke: #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/pay_system_popups/pay_diff_money_popup.vue